//classe  che gestisce gli elementi primary
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SalutiService from '../services/Api/Saluti/Saluti.js';
import AutenthicationService from '../services/authservice.js';

export default class WelcomComponent extends Component {
  state = {
    StringMsg: '',
    StringMsgRasp: '',
  };

  onFocus = (e) => {
    e.target.blur();
  };
  getSalutiAxios = (e) => {
    console.log(e.target.id);
    e.preventDefault();
    if (e.target.id === 'saluti') {
      console.log(AutenthicationService.getUserInfo());
      SalutiService.getSaluti(AutenthicationService.getUserInfo())
        .then((response) => this.handleResponse(response, 'saluti'))
        .catch((error) => this.handleError());
    } else {
      SalutiService.getLogin()
        .then((response) => this.handleResponse(response, 'login'))
        .catch((error) => this.handleError());
    }
  };
  handleError = (error) => {
    console.log(error);
  };
  handleResponse = (response, id) => {
    console.log(response.data);
    if (id === 'saluti') {
      this.setState({
        StringMsg: response.data,
      });
    } else {
      this.setState({
        StringMsgRasp: response.data.ms,
      });
    }
  };
  getSaluti = (e) => {
    e.preventDefault();
    console.log('getSaluti');
    fetch('http://localhost:8080/api/saluti/ina')
      .then((response) => response.text())
      .then((data) => console.log(data));
  };
  render() {
    return (
      <div className='WelcomComponent container py-5'>
        <div className='row py-5'>
          <p>Componente Welcome</p>
        </div>
        <div className='row'>
          <p className=''>
            Saluti {this.props.match.params.userid},
            <Link to='/clienti'> qui </Link>clicca per vedere i clienti
          </p>
        </div>
        <div className='row'>
          <button
            className='btn  btn-primary btn-block'
            id='saluti'
            name='saluti'
            onClick={this.getSalutiAxios}
            onFocus={this.onFocus}
          >
            <i className='fas fa-dice-six m-4 p-4' id='saluti'>
              &nbsp;visualizza i saluti restxx
            </i>
          </button>
          <h3>{this.state.StringMsg}</h3>
        </div>

        <div className='row py-4'>
          <button
            className='btn  btn-primary btn-block'
            id='login'
            name='login'
            onClick={this.getSalutiAxios}
            onFocus={this.onFocus}
          >
            <i className='fas fa-dice-six m-4 p-4 ' id='login'>
              &nbsp;visualizza Login Rasp
            </i>
          </button>
          <h3>{this.state.StringMsgRasp}</h3>
        </div>
      </div>
    );
  }
}
